var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatmapanalyzer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 500 500",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m291.145 349.452c-72.977 0-132.35-59.372-132.35-132.35 0-72.981 59.373-132.353 132.35-132.353 72.981 0 132.353 59.372 132.353 132.353 0 72.978-59.373 132.35-132.353 132.35zm0-248.689c-64.148 0-116.336 52.191-116.336 116.339 0 64.149 52.188 116.336 116.336 116.336s116.34-52.188 116.34-116.336c-.001-64.148-52.192-116.339-116.34-116.339z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.072 466.605c-14.269 0-27.686-5.557-37.779-15.651-10.093-10.093-15.65-23.51-15.65-37.782 0-14.269 5.557-27.686 15.65-37.779l71.667-71.667c-41.863-78.322-20.946-177.216 50.027-232.366 65.984-51.278 161.265-50.534 226.552 1.76 41.698 33.397 66.268 80.916 69.184 133.805 2.874 52.169-16.651 103.262-53.57 140.181-57.349 57.352-145.592 70.194-216.631 32.183l-71.667 71.664c-10.094 10.094-23.512 15.652-37.783 15.652zm195.994-417.236c-36.262 0-72.514 11.526-102.252 34.633-66.322 51.538-84.803 144.869-42.99 217.099 1.818 3.14 1.295 7.109-1.269 9.675l-75.94 75.939c-14.587 14.59-14.587 38.326 0 52.917 14.587 14.59 38.329 14.59 52.917 0l75.94-75.939c2.564-2.562 6.531-3.078 9.674-1.27 65.643 38.004 148.992 27.048 202.685-26.638 33.703-33.704 51.528-80.349 48.904-127.977-2.662-48.282-25.109-91.675-63.204-122.188-30.152-24.146-67.311-36.251-104.465-36.251z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.012 345.243c-2.049 0-4.098-.782-5.661-2.346l-32.118-32.121c-3.128-3.128-3.128-8.198 0-11.322 3.127-3.128 8.194-3.128 11.322 0l32.118 32.121c3.128 3.127 3.128 8.198 0 11.322-1.564 1.564-3.613 2.346-5.661 2.346z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.279,
    cy: 217.101,
    rx: 21.958,
    ry: 21.958,
    transform: "matrix(.985 -.176 .176 .985 -32.627 65.177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.977 164.1c0-12.128 9.832-21.958 21.958-21.958 12.128 0 21.958 9.831 21.958 21.958s-9.831 21.958-21.958 21.958-21.958-9.831-21.958-21.958z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.626,
    cy: 275.607,
    rx: 21.958,
    ry: 21.958,
    transform: "matrix(.707 -.707 .707 .707 -117.962 266.428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.322 225.109h-118.854c-4.422 0-8.006-3.584-8.006-8.007 0-4.422 3.584-8.006 8.006-8.006h118.854c4.422 0 8.006 3.584 8.006 8.006 0 4.423-3.584 8.007-8.006 8.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.109 172.105h-63.215c-4.423 0-8.007-3.584-8.007-8.006 0-4.423 3.584-8.007 8.007-8.007h63.215c4.423 0 8.007 3.584 8.007 8.007 0 4.421-3.584 8.006-8.007 8.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.161 283.615h-67.677c-4.422 0-8.006-3.584-8.006-8.006 0-4.423 3.584-8.007 8.006-8.007h67.677c4.422 0 8.006 3.584 8.006 8.007 0 4.422-3.584 8.006-8.006 8.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.903 466.605h-356.896c-4.423 0-8.007-3.584-8.007-8.007 0-4.422 3.584-8.006 8.007-8.006h356.896c4.423 0 8.007 3.584 8.007 8.006 0 4.423-3.584 8.007-8.007 8.007z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapanalyzer);
export default __webpack_public_path__ + "static/media/heatmapanalyzer.fb60c20e795e22b829949b7457a3dfbd.svg";
export { ForwardRef as ReactComponent };